import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { IGetReportsParams } from "../../../api/types/reports/IGetReportsParams";
import { IReportInfo } from "../../../api/types/reports/IReportInfo";
import { ReportAction } from "../../../api/types/reports/ReportAction";
import { ReportStatus } from "../../reports/types/reportStatus";

export const getTicketGridInfo = createAsyncThunk<IReportInfo, number>(
  "ticketGrids/getInfo",
  async (id, thunkAPI) => {
    const params: IGetReportsParams = {
      action: ReportAction.getReports,
      status: ReportStatus.template,
      grids: true,
    };
    const response = await endpoints.report.list(params, thunkAPI.signal);
    if (response.error) {
      throw new Error(response.error);
    }

    const info = response.reports?.find((report) => Number(report.id) === id);
    if (!info) {
      throw new Error("Билетная сетка не найдена");
    }

    return info;
  },
);
